import SkidAndRollGraphStyle from './SkidAndRollGraph.module.scss';
import * as React from 'react';
import { observer } from 'mobx-react';
import * as d3 from 'd3';
import { ISkidAndRollGraphParams } from './ISkidAndRollGraphParams';
import { Parameter } from 'MeasurementsCalculations';
import { ISkidAndRollParameterNumberParams } from './../SkidAndRollParameterNumber/ISkidAndRollParameterNumberParams';
import { SkidAndRollParameterNumber } from './../SkidAndRollParameterNumber/SkidAndRollParameterNumber';
import { SkidAndRollParameterLine } from './../SkidAndRollParameterLine/SkidAndRollParameterLine';
import { ISkidAndRollParameterLineParams } from './../SkidAndRollParameterLine/ISkidAndRollParameterLineParams';

@observer
export class SkidAndRollGraph extends React.Component<ISkidAndRollGraphParams, undefined> {
  private axisElement;
  private graphElement;
  private furthestVerticallyPoint: number;
  private furthestHorizontallyPoint: number;
  private ballSpeedText: string;
  private ballSpeedValue: string;
  private ballSpeedUnit: string;
  private speedDropInformationalBoxY: number;
  private speedDropText: string;
  private speedDropValue: string;
  private speedDropUnit: string;
  private rollSpeedInformationalBoxY: number;
  private rollSpeedText: string;
  private rollSpeedValue: string;
  private rollSpeedUnit: string;
  private skidInformationalBoxX: number;
  private skidInformationalBoxY: number;
  private skidText: string;
  private skidValue: string;
  private skidUnit: string;
  private rollPercentageInformationalBoxX: number;
  private rollPercentageInformationalBoxY: number;
  private rollPercentageText: string;
  private rollPercentageValue: string;
  private rollPercentageUnit: string;
  private totalText: string;
  private totalValue: string;
  private totalUnit: string;
  private totalInformationalBoxX: number;
  private totalInformationalBoxY: number;
  private xAxisScale: any;
  private skidDistance: number;
  private rollSpeed: number;
  private total: number;
  private skidDistanceInUnit: number;
  private ballSpeed: number;
  private yAxisScale: any;
  private totalInUnit: number;
  private yAxis: any;
  private xAxis: any;

  //private xAxisElement: SVGElement;

  constructor(props: ISkidAndRollGraphParams) {
    super(props, undefined);
  }

  componentDidMount() {
    this.renderGraphLines(this.graphElement);
  }

  componentDidUpdate() {
    //this.renderGraphLines(element);
    if (this.graphElement) this.renderGraphLines(this.graphElement);
  }

  calculateMaximumWidthAndHeightOfTheGraph() {
    if (this.props.measurementsData.total !== null) {
      this.furthestVerticallyPoint = this.props.measurementsData.ballSpeed;
      this.furthestHorizontallyPoint = this.props.measurementsData.total;
    }
  }

  calculateAFromPolynomium(x1: number, y1: number, x2: number, y2: number): number {
    var a = (y2 - y1) / (x2 - x1);
    return a;
  }
  calculateBFromPolynomium(x: number, y: number, a: number) {
    var b = y - a * x;
    return b;
  }

  calculateXPointOnSlope(x1: number, y1: number, x2: number, y2: number, lineYPoint: number) {
    var a = this.calculateAFromPolynomium(x1, y1, x2, y2);
    var b = this.calculateBFromPolynomium(x2, y2, a);
    var x = (lineYPoint - b) / a;

    return x;
  }

  calculateYPointOnSlope(x1: number, y1: number, x2: number, y2: number, lineXPoint: number) {
    var a = this.calculateAFromPolynomium(x1, y1, x2, y2);
    var b = this.calculateBFromPolynomium(x2, y2, a);

    var y = a * lineXPoint + b;

    return y;
  }

  tickCountSetter(n) {
    if (n < 5) {
      return n;
    } else {
      return 5;
    }
  }

  calculateColorWithOpacity(color: string, opacity): string {
    if (color) {
      //The opacity in the skid and roll was implemented in this way, because in TPS when printing the opacity in svg images causes problems like scaling and translating the parts where opacity is used.
      let hex = color.replace('#', '');

      //Color that needs to have opacity applied
      let r1 = parseInt(hex.substring(0, 2), 16);
      let g1 = parseInt(hex.substring(2, 4), 16);
      let b1 = parseInt(hex.substring(4, 6), 16);

      //White color
      let r2 = 255;
      let g2 = 255;
      let b2 = 255;

      //Color with opacity blended with white to get a solid color that looks like the color with opacity on white background

      let r3 = Math.round(r2 + (r1 - r2) * opacity);
      let g3 = Math.round(g2 + (g1 - g2) * opacity);
      let b3 = Math.round(b2 + (b1 - b2) * opacity);
      return 'rgb(' + r3 + ',' + g3 + ',' + b3 + ')';
    }
    return 'rgb(255, 255, 255, 1)';
  }

  renderGraphLines(element: SVGElement) {
    const xAxisScale = this.xAxisScale,
      skidDistance = this.skidDistance,
      rollSpeed = this.rollSpeed,
      total = this.total,
      skidDistanceInUnit = this.skidDistanceInUnit,
      ballSpeed = this.ballSpeed,
      yAxisScale = this.yAxisScale,
      totalInUnit = this.totalInUnit;
    var svgContainer = d3.select(element);
    //let virteEl = document.createElementNS("http://www.w3.org/2000/svg", "g");

    svgContainer.selectAll('g.gridLines').remove();

    var gridLineGroup = svgContainer.append('g').attr('class', 'gridLines');

    svgContainer.attr('class', 'verticalGrid');

    //var axis = d3.select(virteEl).call(this.xAxis);
    //var axis = svgContainer.call(this.xAxis);
    var self = this;
    //axis.selectAll(".tick").each(function (tick) {
    svgContainer.selectAll('.x .tick').each(function(this: any, tick) {
      //

      var tickObject = d3.select(this);
      var transform = d3.transform(tickObject.attr('transform')).translate;
      var tickPoint = transform[0];
      var tickInNormalScale = xAxisScale.invert(tickPoint);

      //Grids for the skid distance
      var y2 = self.calculateYPointOnSlope(skidDistance, rollSpeed, total, 0, tickInNormalScale);
      if (tick <= skidDistanceInUnit) {
        var y3 = self.calculateYPointOnSlope(
          0,
          ballSpeed,
          skidDistance,
          rollSpeed,
          tickInNormalScale
        );
        //$(element).find(".verticalGrid").append("<line x1=" + tickPoint + " y1=" + yAxisScale(0) + " x2=" + tickPoint + " y2=" + yAxisScale(y3) + " fill='none' stroke='#a0a0a0' strokeWidth='1px'></line>");
        gridLineGroup
          .append('line')
          .attr('x1', tickPoint)
          .attr('y1', yAxisScale(0))
          .attr('x2', tickPoint)
          .attr('y2', yAxisScale(y3))
          .attr('fill', 'none')
          .attr('stroke', '#a0a0a0')
          .attr('strokeWidth', '1px');
      }

      if (tick <= totalInUnit && tick > skidDistanceInUnit) {
        //Grids for the roll area
        //$(element).find(".verticalGrid").append("<line class='verticalGridRoll' x1=" + tickPoint + " y1=" + yAxisScale(0) + " x2=" + tickPoint + " y2=" + yAxisScale(y2) + " fill='none' stroke='#a0a0a0' strokeWidth='1px'></line>");
        gridLineGroup
          .append('line')
          .attr('class', 'verticalGridRoll')
          .attr('x1', tickPoint)
          .attr('y1', yAxisScale(0))
          .attr('x2', tickPoint)
          .attr('y2', yAxisScale(y2))
          .attr('fill', 'none')
          .attr('stroke', '#a0a0a0')
          .attr('strokeWidth', '1px');
      }
    });

    var rollSpeedInUnit = this.props.unitPresentation.value(Parameter.RollSpeed, rollSpeed);
    var ballSpeedInUnit = this.props.unitPresentation.value(Parameter.BallSpeed, ballSpeed);

    svgContainer.selectAll('.y .tick').each(function(this: any, tick) {
      var tickObject = d3.select(this);
      var transform = d3.transform(tickObject.attr('transform')).translate;
      var tickPoint = transform[1];
      var tickInNormalScale = yAxisScale.invert(tickPoint);

      var x2 = self.calculateXPointOnSlope(skidDistance, rollSpeed, total, 0, tickInNormalScale);
      //Grids for the skid distance
      if (tick >= rollSpeedInUnit && tick < ballSpeedInUnit) {
        var x3 = self.calculateXPointOnSlope(
          0,
          ballSpeed,
          skidDistance,
          rollSpeed,
          tickInNormalScale
        );

        gridLineGroup
          .append('line')
          .attr('class', 'horizontalGrid')
          .attr('x1', xAxisScale(0))
          .attr('y1', tickPoint)
          .attr('x2', xAxisScale(x3))
          .attr('y2', tickPoint)
          .attr('fill', 'none')
          .attr('stroke', '#a0a0a0')
          .attr('strokeWidth', '1px');
      }

      //Grids for the roll area
      if (tick <= rollSpeedInUnit && tick >= 0) {
        gridLineGroup
          .append('line')
          .attr('class', 'horizontalGridRoll')
          .attr('x1', xAxisScale(skidDistance))
          .attr('y1', tickPoint)
          .attr('x2', xAxisScale(x2))
          .attr('y2', tickPoint)
          .attr('fill', 'none')
          .attr('stroke', '#a0a0a0')
          .attr('strokeWidth', '1px');
      }

      if (tick <= rollSpeedInUnit && tick >= 0) {
        //Grids for the rectangle
        gridLineGroup
          .append('line')
          .attr('class', 'horizontalGridSkid')
          .attr('x1', xAxisScale(0))
          .attr('y1', tickPoint)
          .attr('x2', xAxisScale(skidDistance))
          .attr('y2', tickPoint)
          .attr('fill', 'none')
          .attr('stroke', '#a0a0a0')
          .attr('strokeWidth', '1px');
      }
    });
  }
  private renderXAxis(element: SVGGElement) {
    if (!element) return;

    d3.select(element).call(this.xAxis);
  }
  private renderYAxis(element: SVGGElement) {
    if (!element) return;

    d3.select(element).call(this.yAxis);
  }

  render() {
    let graphColor = '#a0a0a0';
    if (this.props.selectedGroupOfStrokes != null) {
      graphColor = this.props.selectedGroupOfStrokes.color;
    }
    //$(this.element).children("#skid-and-roll-view-container").empty();
    if (this.props.measurementsData === null) {
      return null;
    }

    if (!this.props.measurementsData?.skidDistance || !this.props.measurementsData?.total) {
      return null;
    }

    this.calculateMaximumWidthAndHeightOfTheGraph();

    let lineFunction = d3.svg
      .line<{ x: number; y: number }>()
      .x(function(d) {
        return d.x;
      })
      .y(function(d) {
        return d.y;
      })
      .interpolate('linear');
    //Margins
    let marginTop = this.props.containerMarginTop;
    let marginBottom = this.props.containerMarginBottom;
    let marginRight = this.props.containerMarginRight;
    let marginLeft = this.props.containerMarginLeft;

    let svgWidthWithMargins = this.props.widthOfContainer;
    let svgHeightWithMargins = this.props.heightOfContainer;
    //if (this.reportKind() === ReportKind."puttingCompareReport") {
    //    marginTop = 60;
    //    marginBottom = 103;
    //    marginRight = 50;
    //    marginLeft = 35;
    //    svgHeightWithMargins = 450;
    //}
    this.skidDistance = this.props.measurementsData.skidDistance;
    this.skidDistanceInUnit = this.props.unitPresentation.value(
      Parameter.Total,
      this.props.measurementsData.skidDistance
    );
    this.rollSpeed = this.props.measurementsData.rollSpeed;
    let speedDrop = this.props.measurementsData.speedDrop;
    let rollPercentage = this.props.measurementsData.rollPercentage;
    this.ballSpeed = this.props.measurementsData.ballSpeed;
    this.total = this.props.measurementsData.total;
    this.totalInUnit = this.props.unitPresentation.value(Parameter.Total, this.total);
    //Margins and dimensions
    let margin = { top: marginTop, right: marginRight, bottom: marginBottom, left: marginLeft },
      width = svgWidthWithMargins - margin.left - margin.right,
      height = svgHeightWithMargins - margin.top - margin.bottom;
    //Scales
    this.xAxisScale = d3.scale
      .linear()
      .domain([0, this.furthestHorizontallyPoint])
      .range([0, width]);
    this.yAxisScale = d3.scale
      .linear()
      .domain([0, this.furthestVerticallyPoint])
      .range([height, 0]);

    //Scales for axis
    let xAxisForScale = d3.scale
      .linear()
      .domain([
        0,
        this.props.unitPresentation.value(Parameter.Total, this.furthestHorizontallyPoint),
      ])
      .rangeRound([0, width]);
    let yAxisForScale = d3.scale
      .linear()
      .domain([
        0,
        this.props.unitPresentation.value(Parameter.BallSpeed, this.furthestVerticallyPoint),
      ])
      .rangeRound([height, 0]);
    //Create the X Axis
    this.xAxis = d3.svg
      .axis()
      .scale(xAxisForScale)
      .orient('bottom')
      .ticks(this.tickCountSetter(this.total));
    //xAxis.tickFormat(d3.format("d"));
    //let xAxisTicks = xAxis.scale().ticks();

    //Create the Y Axis
    this.yAxis = d3.svg
      .axis()
      .scale(yAxisForScale)
      .orient('left')
      .ticks(this.tickCountSetter(this.ballSpeed));
    //let yAxisTicks = yAxis.scale().ticks();

    this.ballSpeedText = this.props.unitPresentation.title(Parameter.BallSpeed);
    this.ballSpeedValue =
      this.ballSpeed != null
        ? this.props.unitPresentation.toString(Parameter.BallSpeed, this.ballSpeed)
        : '-';
    this.ballSpeedUnit = this.props.unitPresentation.displayUnit(Parameter.BallSpeed);
    this.speedDropText = this.props.unitPresentation.title(Parameter.SpeedDrop);
    this.speedDropValue =
      speedDrop != null
        ? this.props.unitPresentation.toString(Parameter.SpeedDrop, speedDrop)
        : '-';
    this.speedDropUnit = this.props.unitPresentation.displayUnit(Parameter.SpeedDrop);
    this.speedDropInformationalBoxY =
      this.ballSpeed !== null && this.rollSpeed !== null && speedDrop !== null
        ? height - this.yAxisScale((this.ballSpeed - this.rollSpeed) / 2) - 40
        : 26;
    this.rollSpeedText = this.props.unitPresentation.title(Parameter.RollSpeed);
    this.rollSpeedValue =
      this.rollSpeed != null
        ? this.props.unitPresentation.toString(Parameter.RollSpeed, this.rollSpeed)
        : '-';
    this.rollSpeedUnit = this.props.unitPresentation.displayUnit(Parameter.RollSpeed);
    this.rollSpeedInformationalBoxY =
      this.rollSpeed != null && this.ballSpeed !== null ? this.yAxisScale(this.rollSpeed) - 40 : 70;
    this.skidText = this.props.unitPresentation.title(Parameter.SkidDistance);
    this.skidValue =
      this.skidDistance != null
        ? this.props.unitPresentation.toString(Parameter.SkidDistance, this.skidDistance)
        : '-';
    this.skidUnit = this.props.unitPresentation.displayUnit(Parameter.SkidDistance);
    this.skidInformationalBoxX =
      this.skidDistance != null ? this.xAxisScale(this.skidDistance / 2) : this.xAxisScale(0);
    this.skidInformationalBoxY = this.yAxisScale(0) + 30;
    this.rollPercentageText = this.props.unitPresentation.title(Parameter.RollPercentage);
    this.rollPercentageValue =
      rollPercentage != null
        ? this.props.unitPresentation.toString(Parameter.RollPercentage, rollPercentage)
        : '-';
    this.rollPercentageUnit = this.props.unitPresentation.displayUnit(Parameter.RollPercentage);
    this.rollPercentageInformationalBoxX =
      this.skidDistance != null || this.total
        ? this.xAxisScale((this.total - this.skidDistance) / 2 + this.skidDistance)
        : this.xAxisScale(width / 2);
    this.rollPercentageInformationalBoxY = this.yAxisScale(0) + 30;
    this.totalText = this.props.unitPresentation.title(Parameter.Total);
    this.totalValue =
      this.total != null ? this.props.unitPresentation.toString(Parameter.Total, this.total) : '-';
    this.totalUnit = this.props.unitPresentation.displayUnit(Parameter.Total);
    this.totalInformationalBoxX =
      (this.total != null ? this.xAxisScale(this.total) : this.xAxisScale(width)) - 20;
    this.totalInformationalBoxY = this.yAxisScale(0) + 30;

    let skidPath = [];
    if (this.props.measurementsData.ballSpeed && this.props.measurementsData.rollSpeed) {
      skidPath = [
        {
          x: this.xAxisScale(0) + 3,
          y: this.yAxisScale(0),
        },
        {
          x: this.xAxisScale(0) + 3,
          y: this.yAxisScale(this.ballSpeed),
        },
        {
          x: this.xAxisScale(this.skidDistance),
          y: this.yAxisScale(this.rollSpeed),
        },
        {
          x: this.xAxisScale(this.skidDistance),
          y: this.yAxisScale(0),
        },
      ];
    }
    let rollDistancePath = [
      {
        x: this.xAxisScale(this.skidDistance),
        y: this.yAxisScale(0),
      },
      {
        x: this.xAxisScale(this.skidDistance),
        y: this.yAxisScale(this.rollSpeed),
      },
      {
        x: this.xAxisScale(this.total),
        y: this.yAxisScale(0),
      },
      {
        x: this.xAxisScale(this.skidDistance),
        y: this.yAxisScale(0),
      },
    ];

    //this.renderGraphLines(element);
    return (
      <div className={SkidAndRollGraphStyle.SkidAndRollGraph}>
        <svg width={this.props.widthOfContainer} height={height}>
          <g
            transform={`translate(${margin.left},${margin.top})`}
            className="verticalGrid"
            ref={el => {
              this.graphElement = el;
            }}
          >
            <g className="background-group">
              <rect
                className="skid-and-roll-background"
                width={width}
                height={height}
                x={0}
                y={0}
              ></rect>
              <g
                className="SkidAndRollAxis x"
                transform={`translate(0, ${height})`}
                ref={node => this.renderXAxis(node)}
              ></g>
              <g
                className="SkidAndRollAxis y"
                transform={`translate(0, 0)`}
                ref={node => this.renderYAxis(node)}
              ></g>
              {this.props.measurementsData.skidDistance && this.props.measurementsData.total && (
                <line
                  className="skidLine"
                  x1={this.xAxisScale(0) + 3}
                  y1={this.yAxisScale(0)}
                  x2={this.xAxisScale(this.skidDistance)}
                  y2={this.yAxisScale(0)}
                ></line>
              )}
              <path
                className="skid-path"
                d={lineFunction(skidPath)}
                stroke={graphColor}
                y={0}
                fill={this.calculateColorWithOpacity(graphColor, 0.4)}
              ></path>
              {this.ballSpeed && this.rollSpeed && (
                <rect
                  x={0}
                  y={this.yAxisScale(this.ballSpeed)}
                  width={5}
                  height={height - this.yAxisScale(this.ballSpeed)}
                  fill={graphColor}
                ></rect>
              )}
              <path
                className="roll-distance-path"
                d={lineFunction(rollDistancePath)}
                stroke={graphColor}
                y={0}
                fill={this.calculateColorWithOpacity(graphColor, 0.2)}
              ></path>
              <rect
                x={this.xAxisScale(this.skidDistance) - 1}
                y={this.yAxisScale(this.rollSpeed)}
                width={5}
                height={height - this.yAxisScale(this.rollSpeed)}
                fill={graphColor}
              ></rect>
              {/*Ball speed number*/}
              <SkidAndRollParameterNumber
                {...this.getBallSpeedNumberParameters()}
              ></SkidAndRollParameterNumber>
              {this.ballSpeed && this.rollSpeed && (
                <SkidAndRollParameterLine
                  {...this.getBallSpeedLineParametres()}
                ></SkidAndRollParameterLine>
              )}
              {/*Speed drop number*/}
              <SkidAndRollParameterNumber
                {...this.getSpeedDropNumberParameters()}
              ></SkidAndRollParameterNumber>
              {this.ballSpeed && this.rollSpeed && speedDrop && (
                <SkidAndRollParameterLine
                  x1={this.xAxisScale(this.skidDistance / 2)}
                  y1={height - this.yAxisScale((this.ballSpeed - this.rollSpeed) / 2)}
                  x2={162}
                  y2={height - this.yAxisScale((this.ballSpeed - this.rollSpeed) / 2)}
                ></SkidAndRollParameterLine>
              )}
              {/*Roll speed number*/}
              <SkidAndRollParameterNumber
                {...this.getRollSpeedNumberParameters()}
              ></SkidAndRollParameterNumber>
              {this.ballSpeed && this.rollSpeed && (
                <SkidAndRollParameterLine
                  x1={this.xAxisScale(this.skidDistance)}
                  y1={this.yAxisScale(this.rollSpeed)}
                  x2={263}
                  y2={this.yAxisScale(this.rollSpeed)}
                ></SkidAndRollParameterLine>
              )}
              {/*Skid number*/}
              <SkidAndRollParameterNumber
                {...this.getSkidNumberParameters()}
              ></SkidAndRollParameterNumber>
              {/*Roll percentage number*/}
              <SkidAndRollParameterNumber
                {...this.getRollPercentageNumberParameters()}
              ></SkidAndRollParameterNumber>
              {/*Total number*/}
              <SkidAndRollParameterNumber
                {...this.getTotalNumberParameters()}
              ></SkidAndRollParameterNumber>
            </g>
          </g>
        </svg>
      </div>
    );
  }
  private getBallSpeedLineParametres() {
    const result: ISkidAndRollParameterLineParams = {
      x1: 0,
      y1: 0,
      x2: 50,
      y2: 0,
    };
    return result;
  }

  private getBallSpeedNumberParameters() {
    const result: ISkidAndRollParameterNumberParams = {
      className: 'top-information',
      informationBoxX: 58,
      informationBoxY: -42,
      informationTitleX: 0,
      informationTitleY: 18,
      informationTitleTextAnchor: 'start',
      informationTitleText: this.ballSpeedText,
      informationValueX: 0,
      informationValueY: 50,
      informationValueTextAnchor: 'start',
      informationValueText: this.ballSpeedValue,
      informationUnitX: 60,
      informationUnitY: 50,
      informationUnitTextAnchor: 'start',
      informationUnitText: this.ballSpeedUnit,
    };
    return result;
  }
  private getSpeedDropNumberParameters() {
    const result: ISkidAndRollParameterNumberParams = {
      className: 'top-information',
      informationBoxX: 162,
      informationBoxY: this.speedDropInformationalBoxY,
      informationTitleX: 0,
      informationTitleY: 18,
      informationTitleTextAnchor: 'start',
      informationTitleText: this.speedDropText,
      informationValueX: 0,
      informationValueY: 50,
      informationValueTextAnchor: 'start',
      informationValueText: this.speedDropValue,
      informationUnitX: 50,
      informationUnitY: 50,
      informationUnitTextAnchor: 'start',
      informationUnitText: this.speedDropUnit,
    };
    return result;
  }
  private getRollSpeedNumberParameters() {
    const result: ISkidAndRollParameterNumberParams = {
      className: 'top-information',
      informationBoxX: 263,
      informationBoxY: this.rollSpeedInformationalBoxY,
      informationTitleX: 0,
      informationTitleY: 18,
      informationTitleTextAnchor: 'start',
      informationTitleText: this.rollSpeedText,
      informationValueX: 0,
      informationValueY: 50,
      informationValueTextAnchor: 'start',
      informationValueText: this.rollSpeedValue,
      informationUnitX: 50,
      informationUnitY: 50,
      informationUnitTextAnchor: 'start',
      informationUnitText: this.rollSpeedUnit,
    };
    return result;
  }

  private getSkidNumberParameters() {
    const result: ISkidAndRollParameterNumberParams = {
      className: 'bottom-information',
      informationBoxX: this.skidInformationalBoxX,
      informationBoxY: this.skidInformationalBoxY,
      informationTitleX: 0,
      informationTitleY: 18,
      informationTitleTextAnchor: 'middle',
      informationTitleText: this.skidText,
      informationValueX: 0,
      informationValueY: 50,
      informationValueTextAnchor: 'middle',
      informationValueText: this.skidValue,
      informationUnitX: 50,
      informationUnitY: 50,
      informationUnitTextAnchor: 'end',
      informationUnitText: this.skidUnit,
    };
    return result;
  }
  private getRollPercentageNumberParameters() {
    const result: ISkidAndRollParameterNumberParams = {
      className: 'bottom-information',
      informationBoxX: this.rollPercentageInformationalBoxX,
      informationBoxY: this.rollPercentageInformationalBoxY,
      informationTitleX: 0,
      informationTitleY: 18,
      informationTitleTextAnchor: 'middle',
      informationTitleText: this.rollPercentageText,
      informationValueX: 0,
      informationValueY: 50,
      informationValueTextAnchor: 'middle',
      informationValueText: this.rollPercentageValue,
      informationUnitX: 40,
      informationUnitY: 50,
      informationUnitTextAnchor: 'end',
      informationUnitText: this.rollPercentageUnit,
    };
    return result;
  }
  private getTotalNumberParameters() {
    const result: ISkidAndRollParameterNumberParams = {
      className: 'bottom-information',
      informationBoxX: this.totalInformationalBoxX,
      informationBoxY: this.totalInformationalBoxY,
      informationTitleX: 0,
      informationTitleY: 18,
      informationTitleTextAnchor: 'middle',
      informationTitleText: this.totalText,
      informationValueX: 0,
      informationValueY: 50,
      informationValueTextAnchor: 'middle',
      informationValueText: this.totalValue,
      informationUnitX: 60,
      informationUnitY: 50,
      informationUnitTextAnchor: 'end',
      informationUnitText: this.totalUnit,
    };
    return result;
  }
}
